module.exports = __webpack_public_path__ + "img/y_2018.cabc14e4.png";